import React from 'react'
import PropTypes from 'prop-types'
import { Field, getIn } from 'formik'
import classNames from 'classnames'

import FormGroup from '../FormGroup'

const MultiSelect = ({
    name,
    label,
    help,
    placeholder,
    options = [],
    className = '',
    tooltip,
    ...props
}) => {
    let opts = options.map(({ label, value }, i) => (
        <option key={i} value={value}>
            {label}
        </option>
    ))

    return (
        <Field name={name}>
            {({ field, form }) => {
                let error = getIn(form.errors, name)

                if (error) {
                    const errorFieldName = label ? label : 'This'
                    error = error.replace(field.name, errorFieldName)
                }

                props.className = classNames('form-control', className)

                if (help) {
                    props['aria-describedby'] = `${name}Help`
                }

                field.onChange = e =>
                    form.setFieldValue(
                        name,
                        [].slice.call(e.target.selectedOptions).map(option => option.value)
                    )

                return (
                    <FormGroup {...{ name, label, help, error, tooltip }}>
                        <select {...field} {...props} disabled={form.isSubmitting} multiple={true}>
                            {placeholder && <option value="">{placeholder}</option>}
                            {opts}
                        </select>
                    </FormGroup>
                )
            }}
        </Field>
    )
}

MultiSelect.displayName = 'MultiSelect'

MultiSelect.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    help: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    placeholder: PropTypes.string,
    options: PropTypes.array.isRequired,
    className: PropTypes.string,
}

export default MultiSelect
